import Model from "~/models/_Model";

export default class EquipmentType extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/techloaner";
  }

  // Set the resource route of the model
  resource() {
    return "equipment-types";
  }

  relations() {
    return {};
  }
}
